'use client';

import { Typography } from "@material-tailwind/react";

const LINKS = [
  {
    title: "Overview",
    href: "/#overview",
  },
  {
    title: "Amenities",
    href: "/#amenities",
  },
  {
    title: "Sleep",
    href: "/#sleep",
  },
  {
    title: "Location, Transport, Activities",
    href: "/#location-transport-activities",
  },
  {
    title: "Pricing",
    href: "/#pricing",
  },
  {
    title: "Reviews",
    href: "/#reviews",
  },
];

function NavList({ selected, onTabChange }: { selected: number, onTabChange: (index: number) => void }) {
    function handleClick(index: number) {
        if (selected < 0 || selected >= LINKS.length) {
            return;
        }
        onTabChange(index);
    }

    return (
        <div className="flex gap-3 !text-base !justify-start">
          {LINKS.map(({ title, href }, index) => (
              <div onClick={() => handleClick(index)} key={title} className={`property-navbar-element relative flex items-center gap-1.5 text-nowrap px-2 py-1.5 after:bg-green-700 ${(index === selected) ? "after:w-full" : "after:w-0"}`}>
                  <Typography
                      as="a"
                      href={href}
                      type="small"
                  >
                      {title}
                  </Typography>

              </div>
          ))}
        </div>
    );
}

export default function PropertyNavBar({ selected, onTabChange }: { selected: number, onTabChange: (index: number) => void }) {
    return (
        <div className="overflow-x-auto no-scrollbar" data-scroll-direction="right">
            <NavList selected={selected} onTabChange={onTabChange} />
        </div>
    );
}
